import { CoverageEntry } from "../../types/index.js";